import { Button } from "../ui/button";
import { Eye } from "lucide-react";

export default function PreviewStrip({
  previewPages,
  previewMeta,
  previewLoading,
  fetchPreview,
}) {
  return (
    <div className="border-t border-zinc-800 pt-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="label-eyebrow flex items-center gap-1">
          <Eye className="w-3 h-3" /> Print preview
          {previewMeta.total_pages > 0 && (
            <span className="text-zinc-500 font-mono normal-case tracking-normal ml-2">
              {previewMeta.total_pages} page{previewMeta.total_pages === 1 ? "" : "s"}
            </span>
          )}
        </div>
        <Button
          data-testid="pdf-preview-btn"
          type="button"
          onClick={fetchPreview}
          disabled={previewLoading}
          variant="ghost"
          className="h-7 text-xs text-zinc-300 hover:text-zinc-50 hover:bg-zinc-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {previewLoading ? (
            <>
              <span className="inline-block w-3 h-3 mr-1.5 rounded-full border-2 border-zinc-500 border-t-zinc-100 animate-spin" />
              Rendering…
            </>
          ) : (previewPages.length ? "Refresh" : "Generate")}
        </Button>
      </div>
      {previewPages.length > 0 && (
        <>
          <div data-testid="pdf-preview-strip" className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
            {previewPages.map((src, i) => (
              <div
                key={i}
                className="shrink-0 bg-zinc-950 border border-zinc-800 rounded-md p-1"
              >
                <img
                  src={src}
                  alt={`Page ${i + 1}`}
                  className="h-32 w-auto rounded-sm"
                />
                <div className="text-[10px] text-zinc-500 text-center mt-1 font-mono">
                  {i + 1}
                </div>
              </div>
            ))}
          </div>
          {previewMeta.truncated && (
            <p className="text-[10px] text-zinc-500">
              Showing first {previewPages.length} pages — download the PDF to see all {previewMeta.total_pages}.
            </p>
          )}
        </>
      )}
    </div>
  );
}
